// Delade formatteringsfunktioner för Meta Statistik-dashboarden.

export function fmtNum(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '–';
  return Math.round(n).toLocaleString('sv-SE');
}

export function fmtSpend(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '–';
  return n.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtPct(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return '–';
  return `${n.toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
}

export function fmtDate(d) {
  if (!d) return '–';
  try { return new Date(d).toLocaleDateString('sv-SE'); } catch (_) { return d; }
}

export function fmtDateTime(d) {
  if (!d) return '–';
  try { return new Date(d).toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short' }); } catch (_) { return d; }
}

export const PLATFORM_LABEL = { facebook: 'Facebook', instagram: 'Instagram' };
export const PLATFORM_COLOR = { facebook: '#1877f2', instagram: '#e1306c' };
